export default "__VITE_ASSET__ab5cbb99__"